module.exports = __webpack_public_path__ + "static/img/decor1.c83b145.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/decor1.svg
// module id = x2DZ
// module chunks = 0